export const DELIVERY_EVENT_PLACEHOLDER = '{EVENT}';
export const DELIVERY_EVENT_LABEL = `Arrives by ${DELIVERY_EVENT_PLACEHOLDER} for`;
export const DELIVERY_EVENT_MORE_OPTIONS = 'More options';
export const LATE_DELIVERY_EVENT_LABEL = `Late for ${DELIVERY_EVENT_PLACEHOLDER}`;
